import {
  Circle,
  Fill,
  Stroke,
  Style,
} from 'ol/style'
import Feature from 'ol/Feature'
import Geolocation from 'ol/Geolocation'
import Point from 'ol/geom/Point'
import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'

export function createGeolocation({ projection }) {
  const geolocation = new Geolocation({
    // enableHighAccuracy must be set to true to have the heading value.
    trackingOptions: {
      enableHighAccuracy: true,
    },
    projection,
  })

  const accuracyFeature = new Feature()
  const positionFeature = new Feature()

  positionFeature.setStyle(
    new Style({
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color: '#3399CC',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 2,
        }),
      }),
    }),
  )

  geolocation.on('change:accuracyGeometry', () => {
    accuracyFeature.setGeometry(geolocation.getAccuracyGeometry())
  })

  geolocation.on('change:position', () => {
    const coordinates = geolocation.getPosition()
    positionFeature.setGeometry(
      coordinates ? new Point(coordinates) : null,
    )
  })

  const layer = new VectorLayer({
    title: 'GPS Position',
    source: new VectorSource({
      features: [
        accuracyFeature,
        positionFeature,
      ],
    }),
    visible: true,
  })

  return {
    geolocation,
    layer,
    start: () => geolocation.setTracking(true),
    stop: () => geolocation.setTracking(false),
  }
}
